/* REGIOS-COLLECTION-008: Read the current Regios customer-tag gate; unsupported rules stay hidden. */
(() => {
  if (window.sgCollectionSale008) {
    window.sgCollectionSale008();
    return;
  }

  let cachedText = '';
  let snapshot = null;

  const getConfig = () => {
    const text = document.getElementById('regios-dopp-config')?.textContent;
    if (!text) return null;
    if (text !== cachedText) {
      snapshot = JSON.parse(text);
      cachedText = text;
    }
    return snapshot;
  };

  const matchesEligibility = (rule, customer) => {
    if (rule?.type === 'ALL_CUSTOMERS') return true;
    if (rule?.type !== 'SPECIFIC_CUSTOMER_TAGS') {
      throw new Error('Unsupported customer rule');
    }
    if (!Array.isArray(rule.tagsToCheck)) {
      throw new Error('Missing customer tags');
    }
    return Boolean(customer && Array.isArray(customer.tags) &&
      rule.tagsToCheck.some(tag => customer.tags.includes(tag)));
  };

  const canSeeSale = (data, discountId) => {
    const raw = data?.discountConfigs?.[discountId];
    if (!raw) return false;
    const discount = typeof raw === 'string' ? JSON.parse(raw) : raw;
    const config = discount.config;
    if (config?.isEnabled !== true) return false;

    for (const [field, isStart] of [['startDate', true], ['endDate', false]]) {
      if (!discount[field]) continue;
      const date = Date.parse(discount[field]);
      if (!Number.isFinite(date)) return false;
      if (isStart ? Date.now() < date : Date.now() >= date) return false;
    }

    if (!matchesEligibility(config.customerEligibility, data.customer)) return false;

    const gate = config.customLogic?.entryPoint;
    if (gate?.type !== 'CHECK_IF' || gate.otherwise != null ||
        !gate.then || !Array.isArray(gate.conditions) ||
        gate.conditions.length === 0) return false;

    const results = gate.conditions.map(condition => {
      if (condition.type !== 'CUSTOMER_ELIGIBILITY') {
        throw new Error('Unsupported customer gate');
      }
      const matched = matchesEligibility(condition.eligibility, data.customer);
      if (condition.includeOrExclude === 'INCLUDE') return matched;
      if (condition.includeOrExclude === 'EXCLUDE') return !matched;
      throw new Error('Unsupported condition');
    });

    if (gate.matchType === 'AND') return results.every(Boolean);
    if (gate.matchType === 'OR') return results.some(Boolean);
    return false;
  };

  const update = () => {
    let data = null;
    try { data = getConfig(); } catch (_) {}

    document.querySelectorAll('.sg-collection-sale[data-sg-regios-sale]').forEach(block => {
      let allowed = false;
      try { allowed = canSeeSale(data, block.dataset.sgRegiosSale); } catch (_) {}
      block.hidden = !allowed;
      if (!allowed) return;

      block.querySelectorAll('[data-sg-sale-countdown]').forEach(timer => {
        const end = Date.parse(timer.dataset.end);
        if (!Number.isFinite(end)) return;
        const total = Math.max(0, Math.ceil((end - Date.now()) / 1000));
        if (!total) {
          timer.textContent = timer.dataset.endedText;
          return;
        }
        const pad = n => String(n).padStart(2, '0');
        timer.textContent = `${Math.floor(total / 86400)}d ${pad(Math.floor(total % 86400 / 3600))}:${pad(Math.floor(total % 3600 / 60))}:${pad(total % 60)} ${timer.dataset.leftText}`;
      });
    });
  };

  window.sgCollectionSale008 = update;
  update();
  document.addEventListener('DOMContentLoaded', update, { once: true });
  document.addEventListener('variant:change', update);
  document.addEventListener('shopify:section:load', update);
  window.addEventListener('regios-dopp:api-initialized', update);
  window.setInterval(update, 1000);
})();
